import React, { forwardRef } from "react";
import styled from "styled-components";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import classNames from "classnames";
import { Col } from "react-bootstrap";

export interface IColProps extends IEditableProps, IStyledProps {
    label: string;
}

export default styled(forwardRef((props: any, ref: any) => {
    const { cmsId, editorClassObj, className } = props;

    return (
        <Col data-id={cmsId} ref={ref} lg className={classNames(className, editorClassObj)}>{props.children}</Col>
    );

}))`
   &:empty {
      min-height: 300px;
      background: ${props => props.theme.gray300};
   }
`;
